import { render } from "./QualificationSkill.vue?vue&type=template&id=35b43866"
import script from "./QualificationSkill.vue?vue&type=script&lang=js"
export * from "./QualificationSkill.vue?vue&type=script&lang=js"

import exportComponent from "/home/paperspace/thehrway-basic/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__